// 📁 src/pages/Unauthorized.jsx
import React from 'react';

const Unauthorized = () => (
  <div className="text-center p-10 text-red-600 font-bold text-xl">
    ⛔ You are not authorized to access this page.
  </div>
);

export default Unauthorized;
